export default __webpack_public_path__ + "static/media/BluesofaCover.5722e562.jpg";